import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]

interface Props {
  count?: number | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientCompletedBadge',
  props: {
    count: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.count != null && __props.count > 0)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "badge rounded-pill bg-info ms-1",
        style: {"font-size":"0.65rem","font-weight":"600","vertical-align":"middle"},
        title: `${__props.count} completed`
      }, _toDisplayString(__props.count), 9, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})